import { api } from "@/utils/api";
import { sanitizePathParam } from "@/utils/sanitize";

export default class InteractiveSimulationRepository {
  async getIterationsBySimulation({
    simulationId,
  }: {
    simulationId: string | number;
  }) {
    try {
      const sid = sanitizePathParam(simulationId);
      const response = await api.get(
        `interactive-simulations/simulations/${sid}/iterations`
      );
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async postIterationSimulation({
    simulationId,
  }: {
    simulationId: string | number;
  }) {
    try {
      const sid = sanitizePathParam(simulationId);
      const response = await api.post(
        `interactive-simulations/simulations/${sid}/iterations`,
        { simulationId }
      );
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
}
